import React, { useState, useEffect } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import externalsGreenPointActions from "../../../redux/actions/externalsGreenPoint";

export default function Search() {
  const [search, setSearch] = useState("");
  const externalGreenPoint = useSelector((state) => state.externalGreenPoint);
  const app = useSelector((state) => state.app);
  const dispatch = useDispatch();

  useEffect(
    () => setSearch(externalGreenPoint.search),
    [externalGreenPoint.search]
  );

  const handleSubmit = () => {
    dispatch(externalsGreenPointActions.setSearch({ search }));
  };
  return (
    <Grid
      container
      alignItems="center"
      spacing={2}
      style={{ marginBottom: 10 }}
    >
      <Grid item>
        <TextField
          variant="outlined"
          margin="dense"
          placeholder="nombre"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          style={{ height: 40, marginTop: 3 }}
          onClick={() => handleSubmit()}
          startIcon={<SearchIcon />}
          disabled={app.loading}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
}
